module.exports = __webpack_public_path__ + "static/media/ramen.d2fc883a.glb";